import { Crown } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { listingPrice, fmtMoney, unitSuffix, vipPrice } from "@/lib/api";

// Compact price display used on listing cards. Shows the VIP-discounted price
// (with the original struck through) when the signed-in user is a VIP member.
export function PriceTag({ listing }) {
  const { user } = useAuth();
  const { settings } = useSettings();
  const p = listingPrice(listing);

  if (!p) {
    return <span className="text-sm font-medium text-[#1A2E26] whitespace-nowrap">Request a Quote</span>;
  }

  const discount = Number(settings?.vip_discount) || 0;
  const isVip = !!(user && user.vip) && discount > 0;
  const suffix = unitSuffix(p.unit);

  if (isVip) {
    const vp = vipPrice(p.amount, discount);
    return (
      <span className="flex flex-col items-end leading-tight whitespace-nowrap">
        <span className="flex items-center gap-1">
          <span className="text-[10px] text-[#8A847C] line-through">{fmtMoney(p.amount)}</span>
          <span className="rounded-full bg-[#C87D55]/15 text-[#C87D55] text-[9px] font-semibold tracking-wide px-1.5 py-0.5 flex items-center gap-0.5">
            <Crown size={9} /> VIP
          </span>
        </span>
        <span className="text-sm font-semibold text-[#1A2E26]">From {fmtMoney(vp)}{suffix}</span>
      </span>
    );
  }

  return <span className="text-sm font-medium text-[#1A2E26] whitespace-nowrap">From {fmtMoney(p.amount)}{suffix}</span>;
}
